// extracted by mini-css-extract-plugin
export default {"container":"container_I_IIv","list":"list_mvk17","showMore":"showMore_hUFGl"};